import { createSlice } from "@reduxjs/toolkit";

export interface ContentState {
  loading: boolean;
  listLoading: boolean;
  actionsLoading: boolean;
  error: null;
  page: number;
  total: number;
  size: number;
  content: any;
  contentForEdit: any;
  totalCount: number;
  contentLogs: any;
  contentLogsCount: number;
  selectedModule: string;
}

const initialContentState: ContentState = {
  loading: false,
  listLoading: false,
  actionsLoading: false,
  error: null,
  page: 0,
  total: 0,
  size: 0,
  content: [],
  contentForEdit: {},
  totalCount: 0,
  contentLogs: [],
  contentLogsCount: 0,
  selectedModule: "terms",
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const contentSlice = createSlice({
  name: "content",
  initialState: initialContentState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.loading = true;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = true;
      }
    },
    // get content

    getAllContent: (state, action) => {
      const { allContent, total, page, size } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.loading = false;
      state.content = allContent;
      state.total = total;
      state.page = page;
      state.size = size;
    },
    getAllContentLogs: (state, action) => {
      const { logs, total } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.loading = false;
      state.contentLogs = logs;
      state.contentLogsCount = total;
    },

    getContentById: (state, action) => {
      const { contentToEdit } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.loading = false;
      state.contentForEdit = contentToEdit;
    },
    updateContentById: (state, action) => {
      const { contentForEdit } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.loading = false;
      state.contentForEdit = contentForEdit;
    },

    setSelectedModule: (state, action) => {
      state.selectedModule = action.payload;
    },
  },
});
